const userAgentPlatformIdentifier: Record<PlatformIdentifier, UserAgentIdentifier> = {
    chromeos: 'CrOS',
    android: 'Android',
    ios: 'iPad|iPhone',
};

export function usePlatform(): Platform {
    const platform: Platform = {} as Platform;

    Object.keys(userAgentPlatformIdentifier).forEach(key => {
        platform[key] = checkUserAgentForMatches(userAgentPlatformIdentifier[key]);
    });

    function checkUserAgentForMatches(identifier: UserAgentIdentifier): boolean {
        return new RegExp(identifier).test(navigator.userAgent);
    }

    return platform;
}

export type PlatformIdentifier = 'chromeos' | 'android' | 'ios';
export type UserAgentIdentifier = 'CrOS' | 'Android' | 'iPad|iPhone';
export type Platform = Record<PlatformIdentifier, boolean>;
